import { useMutation, useQuery, useQueryClient } from "react-query"
import { getCrewMembers, getQboEmployees, updateCrewMember } from "./crewMemberApi"

export const useCrewMembers = () => {
  return useQuery(['crew-members'], getCrewMembers)
}

export const useUpdateCrewMember = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateCrewMember,
    onSettled: () => {
      queryClient.invalidateQueries('crew-members')
      queryClient.invalidateQueries('scheduleCrew')
    },
    onMutate: async (crewMember) => {
      queryClient.setQueryData(['crew-members'], (oldData: any) => {
        return oldData.map((oldCrewMember: any) => {
          if (oldCrewMember.id === crewMember.id) {
            return crewMember
          }
          return oldCrewMember
        })
      })
    }
  })
}

export const useQboEmployees = () => {
  return useQuery(['qbo-employees'], getQboEmployees)
}
